import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  label: {
    font: 'National 40px serif'
  },
  milestoneIcon: {
    backgroundColor: 'red'
  }
}))
